module.exports = {
  "country": "IT",
  "artist": "Mahmood",
  "song": "Soldi",
  "year": "2019",
  "place": "2",
  "spotify": "4szQkW1CDHqbRZGltXJdd3"
};